module.exports = __webpack_public_path__ + "img/arrow_right.a54fd54c.svg";